import dayjs from '@srm/ui/lib/dayjs';
import { parseRuDate, parseRuDateTime } from '@utils/date';
import { toLocalDate } from '@srm/ui/lib/toLocalDate';

/** Парсит значение даты вложения (RU-строка `DD.MM.YYYY[ HH:mm:ss]`, ISO или timestamp). */
function parseAttachDate(value: unknown): dayjs.Dayjs | null {
    if (value == null || value === '') return null;
    const s = String(value);
    const ru = parseRuDateTime(s) ?? parseRuDate(s);
    const d = ru ? dayjs(ru) : dayjs(toLocalDate(value as Date | string | number));
    return d.isValid() ? d : null;
}

/** Человекочитаемая дата: сегодня/вчера + время, «24 июн, 12:14» в этом году, «24 июн 2025» иначе. */
export function humanizeDateTime(value: unknown): string {
    const d = parseAttachDate(value);
    if (!d) return '—';
    const now = dayjs();
    const time = d.format('HH:mm');
    if (d.isSame(now, 'day')) return `сегодня, ${time}`;
    if (d.isSame(now.subtract(1, 'day'), 'day')) return `вчера, ${time}`;
    if (d.isSame(now, 'year')) return d.format('D MMM, HH:mm');
    return d.format('D MMM YYYY');
}
